export const FREE_TEST = {
	yearly: 'price_1RBNhnRs9Kxk3FYqyGL5VO3S',
	biweekly: 'price_1RBNhnRs9Kxk3FYqyGL5VO3S',
	link: {
		yearly: 'https://buy.stripe.com/test_cN2bLt1JG02rcww7NT',
		biweekly: 'https://buy.stripe.com/test_cN2bLt1JG02rcww7NT',
	},
};
export const FREE = {
	free: process.env.REACT_APP_TEST === 'true' ? 'price_1RBNhnRs9Kxk3FYqyGL5VO3S' : 'price_1RD95eRs9Kxk3FYqhnbl4tBq',
	yearly: process.env.REACT_APP_TEST === 'true' ? 'price_1RBNhnRs9Kxk3FYqyGL5VO3S' : 'price_1RD95eRs9Kxk3FYqhnbl4tBq',
	biweekly: 'price_1RD95eRs9Kxk3FYqhnbl4tBq',
	link: {
		yearly: 'https://buy.stripe.com/8wM0006Wn4io3JK288',
		biweekly: 'https://buy.stripe.com/8wM0006Wn4io3JK288',
	},
};

export const APPRENTICE_TEST = {
	biweekly: 'price_1RBN9DRs9Kxk3FYqX0WDcEsz',
	yearly: 'price_1RBNBIRs9Kxk3FYqjqOlBEWP',
	link: {
		yearly: 'https://buy.stripe.com/test_7sI4j10FC9D16886HV',
		biweekly: 'https://buy.stripe.com/test_eVag1J1JG16veEE8S3',
	},
};

export const APPRENTICE = {
	biweekly: process.env.REACT_APP_TEST === 'true' ? 'price_1RBN9DRs9Kxk3FYqX0WDcEsz' : 'price_1TP9M8Rs9Kxk3FYqH5yN5hgO',
	yearly: process.env.REACT_APP_TEST === 'true' ? 'price_1RBNBIRs9Kxk3FYqjqOlBEWP' : 'price_1REIgjRs9Kxk3FYqbrBgPurS',
	link: {
		yearly: 'https://buy.stripe.com/28o4gg4OfdSY0xybIZ',
		biweekly: 'https://buy.stripe.com/28o288dkL16c3JK28q',
	},
};

export const MASTER_TEST = {
	biweekly: 'price_1RBNKARs9Kxk3FYqT5DZW2Oq',
	yearly: 'price_1RBNM8Rs9Kxk3FYq3uQUdKCL',
	link: {
		yearly: 'https://buy.stripe.com/test_6oE3eX5ZW02rdAA4zO',
		biweekly: 'https://buy.stripe.com/test_aEUaHp5ZWg1p9kkgip',
	},
};

export const MASTER = {
	biweekly: process.env.REACT_APP_TEST === 'true' ? 'price_1RBNKARs9Kxk3FYqT5DZW2Oq' : 'price_1TP9JMRs9Kxk3FYq5T4mTn8e',
	yearly: process.env.REACT_APP_TEST === 'true' ? 'price_1RBNM8Rs9Kxk3FYq3uQUdKCL' : 'price_1REIaERs9Kxk3FYqqdxE5aeP',
	link: {
		yearly: 'https://buy.stripe.com/14k14480rcOU1BC14j',
		biweekly: 'https://buy.stripe.com/3cs2882G75msbcc4gw',
	},
};

export const ORACLE_TEST = {
	biweekly: 'price_1RBNZDRs9Kxk3FYqcp28x4mX',
	yearly: 'price_1RBNZDRs9Kxk3FYqChf8jAUJ',
	link: {
		yearly: 'https://buy.stripe.com/test_5kAeXFfAwcPd5446HT',
		biweekly: 'https://buy.stripe.com/test_8wMeXF1JG3eD8gg4zz',
	},
};

export const ORACLE = {
	biweekly: process.env.REACT_APP_TEST === 'true' ? 'price_1RBNZDRs9Kxk3FYqcp28x4mX' : 'price_1TP9DrRs9Kxk3FYqxTuR3Udj',
	yearly: process.env.REACT_APP_TEST === 'true' ? 'price_1RBNZDRs9Kxk3FYqChf8jAUJ' : 'price_1REISzRs9Kxk3FYq3QDfHpOQ',
	link: {
		yearly: 'https://buy.stripe.com/4gwbII94vaGMbcc6oB',
		biweekly: 'https://buy.stripe.com/00g7ss2G79CI80000e',
	},
};
